/*
 * NOTE
 * 
 * to resize the image use image file resizer. the problem is that the resizer converts the image into a base64 string
 * but we need a File object in FormData as our PHP API is using the $_FILE variable  
 * see
 * https://stackoverflow.com/questions/35940290/how-to-convert-base64-string-to-javascript-file-object-like-as-from-file-input-f
 * 
 */

import React, { useState} from 'react';
import {Input, Box, Container, Button, Alert} from '@mui/material';

import Resizer from "react-image-file-resizer";


// import axios from 'axios';
import * as Config from '../Config.js'; 
import { useNavigate,  useParams } from 'react-router-dom';
import TopAppBar from './TopAppBar' ;

import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";

function PictureScreen() {
    const {t} = useTranslation() ;
    const [image, setImage] = useState(null) ;
    const [message, setMessage] = useState("") ;
    
    const [uploading, setUploading] = useState(false) ;
    const navigate = useNavigate();
    const {id_event, type} = useParams() ;
    
    
    const urltoFile = async (url, filename, mimeType) => {
        let t = await fetch(url) ;
        let tt = await t.arrayBuffer();
        return new File([tt], filename,{type:mimeType});
        /*
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
         * 
         */
    }
    
    const createFormData = () => {
        const data = new FormData();
        data.append('photo', image);
        data.append('id_event', id_event);
        /*
        Object.keys(context.event).forEach((key) => {
            data.append(key, context.event[key]);
        });
        */
        console.log(data) ;
        return data;
    };
    
    
    const uploadPicture = () => {
        
        if (!image) {
            setMessage(t("Please Choose Picture")) ;
            return ;
        }
        setUploading(true) ;
 
        fetch(Config.apiUrl  + '/site/upload', {
          method: 'POST',
          credentials: 'include',
          body: createFormData(),
        })
        
        .then(response => response.json())
        // axios.post(Config.apiUrl + '/addEvent', { id_user: context.user.id, name: eventName})
        .then(res => {
            if (res.success) {
                setUploading(false) ;
                navigate('/event/'+id_event+'/'+type) ;
            } else {
                alert(res.error) ;
            }    
           
          })
          .catch((error) => {
            console.log('error', error);
          });
      };
    
    // TODO change eventually syntax to async await
    
    const resizeFile = (file) =>
      new Promise((resolve) => {
        Resizer.imageFileResizer(
          file,
          500,
          500,
          "JPEG",
          100,
          0,
          (uri) => {
            resolve(uri);
          },
          "base64"
        );
      });    
 
    const onChange = async (event) => {
        const file = event.target.files[0];
        const img = await resizeFile(file);
        console.log('onChange');
        console.log(img) ;
    //    setImage(img) ;
    //    setImage(img) ;
                
        /*
        urltoFile(img, 'filename','text/plain')
            .then(function(file){
                console.log(file) ;
                setImage(file);
        });
         * 
         */
        let fi = await urltoFile(img, 'filename','text/plain') ;
        console.log(fi) ;
        setImage(fi) ;
    } 
   
    return (
        <Container maxWidth="sm">
        <TopAppBar 
            title={t("Choose Picture")}
            returnLink="/event"
            />
        <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' },
            }}
            noValidate
            autoComplete="off"
            textAlign = "center"
            marginTop = "5%"
            width="100%"
        >
            <div>
                <Input 
                    type="file"
                    onChange={(e) => onChange(e)}
                    style={{"width" : "100%"}}
                />
            </div>
            {message && 
                <Alert severity="error">{message}</Alert>
            }
            <Button 
                variant="outlined" 
                onClick={ () => uploadPicture()}
                sx={{"marginTop" : "5%"}}
            >
                {t("Upload")}
            </Button>
            
             {uploading && 
                <Loader type="Circles" color="#00BFFF" height={80} width={80}/>    
            }

            
            
        </Box>    
        </Container>
    )   
    
}
export default PictureScreen;